export default {
  menu: {
    overview: 'Overview',
    products: 'Products',
    server: 'Elastic Cloud Computing',
    lightServer:'Light Server',
    baremetal: 'Bare Metal Server',
    mysql: 'MySQL',
    elb: 'Elastic Load Balancer',
    ssl: 'SSL Certificate',
    ip: 'Anti-DDoS IP',
    account: 'Account',
    billing: 'Billing',
    profile: "My Profile",
    help: 'Help & Support',
    referral: 'Referral Program',
  }

}



// WEBPACK FOOTER //
// ./src/lang/en/menu.js